module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar message = '';\nvar title = '';\nvar sizeClass = 'tiny';\nvar additionalClasses = [];\nif(model && model.decisionScope){\nif(model.decisionScope.title){\ntitle = model.decisionScope.title;\n}\nelse {\ntitle = storage.__('error:confirm.noTitleGiven');\n}\nif(model.decisionScope.message){\nmessage = model.decisionScope.message;\n}\nelse {\nmessage = storage.__('error:confirm.noMessageGiven');\n}\nif(model.decisionScope.sizeClass){\nsizeClass = model.decisionScope.sizeClass;\n}\n}\nadditionalClasses.push(sizeClass);\nif(model.decisionScope.showLineFeeds){\nadditionalClasses.push('showLineFeeds');\n}\nif(model.decisionScope.additionalStyleClasses){\nif(Array.isArray(model.decisionScope.additionalStyleClasses)){\nadditionalClasses = additionalClasses.concat(model.decisionScope.additionalStyleClasses);\n} else {\nadditionalClasses.push(model.decisionScope.additionalStyleClasses);\n}\n}\n%><div class=\"fieldIndependent loading\">\n<div class=\"background\" data-field-type=\"cancel\"></div>\n<div class=\"window <%- additionalClasses.join(' ') %>\">\n<section class=\"header\">\n<div class=\"title\"><%= title %></div>\n<button class=\"close\" data-field-type=\"cancel\">\n<i class=\"fi fi-window-close\"></i>\n</button>\n</section>\n<section class=\"body\">\n<p><%= message %></p>\n</section>\n<%- helpers.renderSection('footer', undefined, true); %>\n</div>\n</div>"
  , __filename = "..\\frontend-controller\\baseComponents\\deciders\\confirm\\confirm.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var message = '';
var title = '';
var sizeClass = 'tiny';
var additionalClasses = [];
if(model && model.decisionScope){
if(model.decisionScope.title){
title = model.decisionScope.title;
}
else {
title = storage.__('error:confirm.noTitleGiven');
}
if(model.decisionScope.message){
message = model.decisionScope.message;
}
else {
message = storage.__('error:confirm.noMessageGiven');
}
if(model.decisionScope.sizeClass){
sizeClass = model.decisionScope.sizeClass;
}
}
additionalClasses.push(sizeClass);
if(model.decisionScope.showLineFeeds){
additionalClasses.push('showLineFeeds');
}
if(model.decisionScope.additionalStyleClasses){
if(Array.isArray(model.decisionScope.additionalStyleClasses)){
additionalClasses = additionalClasses.concat(model.decisionScope.additionalStyleClasses);
} else {
additionalClasses.push(model.decisionScope.additionalStyleClasses);
}
}

    ; __line = 34
    ; __append("<div class=\"fieldIndependent loading\">\n<div class=\"background\" data-field-type=\"cancel\"></div>\n<div class=\"window ")
    ; __line = 36
    ; __append( additionalClasses.join(' ') )
    ; __append("\">\n<section class=\"header\">\n<div class=\"title\">")
    ; __line = 38
    ; __append(escapeFn( title ))
    ; __append("</div>\n<button class=\"close\" data-field-type=\"cancel\">\n<i class=\"fi fi-window-close\"></i>\n</button>\n</section>\n<section class=\"body\">\n<p>")
    ; __line = 44
    ; __append(escapeFn( message ))
    ; __append("</p>\n</section>\n")
    ; __line = 46
    ; __append( helpers.renderSection('footer', undefined, true) )
    ; __append("\n</div>\n</div>")
    ; __line = 48
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\deciders\confirm\confirm.ejs

}